import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {LoginFuncionario, Usuario} from './models/interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const scopes = (route.data as any).expectedScopes;

    const p = localStorage.getItem('Ponto');
    const c = localStorage.getItem('Usuario');
    if (p !== null) {
      const ponto = JSON.parse(p) as LoginFuncionario;
      // console.log(ponto);
      if (ponto.token === '' || ponto.token === null) {
        localStorage.removeItem('Ponto');
        this.router.navigate(['login']);
        // console.log('Não Passou 2');
        return false;
      } else {
        return true;
      }
    } else if (c !== null) {
      const cliente = JSON.parse(c) as Usuario;
      // console.log(cliente);
      if (cliente.token === '' || cliente.token === null) {
        localStorage.removeItem('Usuario');
        this.router.navigate(['login']);
        // console.log('Não Passou 3');
        return false;
      }
      return true;
    } else {
      // console.log('Não Passou 1');
      return false;
    }
  }
}
